import { useSyncExternalStore } from "react";

// Whether previews opened from this browser skip the organization's saved
// device state. The choice lives on the device rather than the account because
// it exists for shared or borrowed machines, where restoring someone's keychain
// and app data is unwanted even though the account is theirs. It applies to the
// next preview: an instance already created with a device state keeps it.
const STORAGE_KEY = "console:deviceStateOff";

const listeners = new Set<() => void>();

function readStored(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === "true";
	} catch {
		return false;
	}
}

let off = readStored();

function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

function getSnapshot() {
	return off;
}

export function setDeviceStateOff(next: boolean) {
	off = next;
	try {
		localStorage.setItem(STORAGE_KEY, String(next));
	} catch {
		// Preference stays in memory for this tab.
	}
	for (const listener of listeners) listener();
}

export function useDeviceStateOff(): [boolean, (next: boolean) => void] {
	const value = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
	return [value, setDeviceStateOff];
}
